import { forConsole } from '../channels';
import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const RING_BELL = 'TRIGGERS/RING_BELL';

export interface IRingBellPayload {
  consoleId: string;
  conversationId: string;
  // deprecated:
  ringBell?: boolean;
  // defaults to true
  endConversation?: boolean;
}

export const ringBellPayloadSchema = objectSchemaOf<IRingBellPayload>({
  consoleId: Joi.string().required(),
  conversationId: Joi.string().required(),
  // deprecated:
  ringBell: Joi.bool().optional(),
  endConversation: Joi.bool(),
});

export interface IRingBellAction {
  type: typeof RING_BELL;
  payload: IRingBellPayload;
}

export const ringBellActionSchema = objectSchemaOf<IRingBellAction>({
  type: Joi.string().required().valid(RING_BELL),
  payload: ringBellPayloadSchema.required(),
});

export const ringBell = actionCreator({
  type: RING_BELL,
  schema: ringBellActionSchema,
  channels: [forConsole],
});
